import React from "react";
import PropTypes from "prop-types";
import { createPortal } from "react-dom";
import { FaExclamationTriangle, FaTimes } from "react-icons/fa";

const AuthServerErrorModal = ({ isOpen, detail, onClose }) => {
  if (!isOpen || typeof document === "undefined") {
    return null;
  }

  const normalizedDetail = detail && typeof detail === "object" ? detail : {};
  const {
    error: errorTitle,
    message: errorMessage,
    code: errorCode,
  } = normalizedDetail;

  const title = errorTitle || "Access temporarily restricted";
  const message =
    errorMessage ||
    "Our servers rejected this request. Please try again later or contact us.";

  const handleSendRequest = () => {
    console.log("Send request clicked with server detail:", normalizedDetail);
  };

  const detailEntries = Object.entries(normalizedDetail).filter(
    ([, value]) => value !== undefined && value !== null && value !== ""
  );

  return createPortal(
    <div className="fixed inset-0 z-[10010] bg-black/50 backdrop-blur-sm px-4 flex items-center justify-center">
      <div className="relative w-full max-w-md rounded-3xl bg-white p-6 text-center shadow-2xl">
        <button
          type="button"
          aria-label="Close server error notice"
          className="absolute right-4 top-4 text-gray-400 hover:text-gray-600 transition"
          onClick={onClose}
        >
          <FaTimes size={18} />
        </button>
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-amber-100 text-amber-600">
          <FaExclamationTriangle size={28} />
        </div>
        <h2 className="flex items-center justify-center text-2xl font-semibold text-gray-900 pb-2">
          {title}
        </h2>
        {/* {errorCode && (
          <span className="inline-flex items-center justify-center rounded-full bg-gray-100 px-4 py-1 text-xs font-semibold uppercase tracking-wide text-gray-600">
            {errorCode}
          </span>
        )} */}
        <p className="mt-4 text-sm text-gray-600">{message}</p>
        {/* {detailEntries.length > 0 && (
          <dl className="mt-5 rounded-2xl bg-gray-50 px-4 py-3 text-left text-sm text-gray-600">
            {detailEntries.map(([key, value]) => (
              <div
                key={key}
                className="flex items-start justify-between py-1 gap-3"
              >
                <dt className="font-medium capitalize text-gray-500">
                  {key.replace(/([A-Z])/g, " $1").trim()}
                </dt>
                <dd className="text-gray-900 text-right break-words">
                  {typeof value === "string" ? value : JSON.stringify(value)}
                </dd>
              </div>
            ))}
          </dl>
        )} */}
        <div className="mt-6 flex flex-col gap-3">
          {/* <button
            type="button"
            onClick={handleSendRequest}
            className="inline-flex w-full items-center justify-center rounded-xl bg-primary px-4 py-3 text-white font-semibold shadow-lg shadow-primary/30 transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 hover:bg-primary-dark"
          >
            Send request
          </button> */}
          <button
            type="button"
            onClick={onClose}
            className="inline-flex w-full items-center justify-center rounded-xl bg-primary px-4 py-3 text-white font-semibold shadow-lg shadow-primary/30 transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 hover:bg-primary-dark"
          >
            Close
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

AuthServerErrorModal.propTypes = {
  isOpen: PropTypes.bool,
  detail: PropTypes.object,
  onClose: PropTypes.func,
};

AuthServerErrorModal.defaultProps = {
  isOpen: false,
  detail: null,
  onClose: () => {},
};

export default AuthServerErrorModal;
